var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedRpl0)",
    d: "M12 18.75a6.799 6.799 0 1 0 0-13.597a6.799 6.799 0 0 0 0 13.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7534",
    fillRule: "evenodd",
    d: "M12 18.847A6.846 6.846 0 0 0 18.846 12a6.846 6.846 0 1 0-13.693 0A6.846 6.846 0 0 0 12 18.847m0-.418A6.429 6.429 0 1 0 12 5.57a6.429 6.429 0 0 0 0 12.858",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD58D",
    fillRule: "evenodd",
    d: "M12 19.286a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572m0-.429a6.857 6.857 0 1 0 0-13.714a6.857 6.857 0 1 0 0 13.714",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m10.104 11.327l-.7.837l.984.369c.012.37.102.525.145.557l-.375.346l.375.382l.368-.382c.205.075.424.101.64.077l.345 1.005l.867-.789l.217-.964c2.001-1.82 2.226-3.274 2.088-3.773c-1.773-.126-3.359 1.333-3.93 2.079zm.042 2.843l-2.97 2.74l-.314-.34l2.97-2.74zm-.952.063l-2.437 2.229l-.313-.342l2.438-2.229zm.88.853l-2.458 2.26l-.312-.34l2.457-2.26zm2.654-3.298a.572.572 0 1 0 0-1.145a.572.572 0 0 0 0 1.145",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedRpl0",
    x1: 5.889,
    x2: 19.285,
    y1: 16.884,
    y2: 7.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#FEBA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#FF9976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6350"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpl);
export default __webpack_public_path__ + "static/media/rpl.aaf555578235b3032b830b232c0c3207.svg";
export { ForwardRef as ReactComponent };